

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { FullPageLoader } from './riskManager/components/HuginnLoader';
import store, { persistor } from './redux/store';
import AuthWrapper from './authWrapper';
import reportWebVitals from './reportWebVitals.js';
import { Auth0Provider } from '@auth0/auth0-react';
import { MantineProvider } from '@mantine/core';
import { theme, cssVariablesResolver } from './riskManager/theme';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dropzone/styles.css';
// Retrieve Auth0 configuration from environment variables
const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
//const redirectUri = window.location.origin;
console.log("Auth0 Domain:", domain);
console.log("Auth0 Client ID:", clientId);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE || 'auth.agenthuginn.ai',
        // Must match scopes actually defined on the `auth.agenthuginn.ai` API, which are:
        // read:models, create:models, delete:models, create:assessment, delete:assessment.
        // This requested `write:models`, which the API has never defined — Auth0 filters
        // undefined scopes out silently, so it was requesting something unobtainable.
        // `offline_access` is required for useRefreshTokens (API has Allow Offline Access on).
        scope: 'openid profile email offline_access read:models create:models delete:models', 
      }}
      useRefreshTokens={true}        // Enable Refresh Tokens
      cacheLocation="localstorage"
    >
      <Provider store={store}>
        {/* Rehydrating the persisted store — the first thing rendered in the app's life, and it
            sits ABOVE MantineProvider, so it cannot be a <Loader>. FullPageLoader is plain CSS
            modules with `--rm-*` fallbacks baked in, so it renders correctly with no provider
            around it. It was an MUI CircularProgress: a second UI framework's spinner, in the
            entry point, contradicting "one loading indicator for the whole product". */}
        <PersistGate loading={<FullPageLoader />} persistor={persistor}>
          <MantineProvider theme={theme} cssVariablesResolver={cssVariablesResolver}>
            <ModalsProvider>
              <Notifications />
              <AuthWrapper />
            </ModalsProvider>
          </MantineProvider>
        </PersistGate>
      </Provider>
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
